// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__9YgPN","slick-next":"CustomSlider_slick-next__3-sbr"};